import { modals } from "@mantine/modals";
import { useForm } from "react-hook-form";
import { TextInput } from "react-hook-form-mantine";
import { useCreateTicket, useUpdateTicket } from "../../api/newTickets";
import { extractDirtyData } from "../../utils/dirtyData";
import { Button } from "@mantine/core";
import resolver from "@congrs/resolver";
import { web_createNewTicketSchema } from "../../../../../packages/schemas/src/newTickets.schema";
import { fullFormats } from "ajv-formats/dist/formats";

const CreateNewTicket = ({ eventId, action, ticketData }) => {
  const { mutate: createTicket, isPending: creatingTicket } = useCreateTicket();
  const { mutate: updateTicket } = useUpdateTicket({
    id: ticketData?.id,
  });

  const {
    control,
    handleSubmit,
    formState: { isDirty, dirtyFields },
    reset,
  } = useForm({
    defaultValues: {
      eventId: ticketData?.eventId || eventId,
      email: ticketData?.email || "",
      firstName: ticketData?.firstName || "",
      lastName: ticketData?.lastName || "",
    },
    resolver: resolver(web_createNewTicketSchema, { formats: fullFormats }),
  });

  const onSubmit = (data) => {
    if (action === "create") {
      createTicket(data, {
        onSuccess: () =>
          reset({
            eventId,
            email: "",
            firstName: "",
            lastName: "",
          }),
      });
    } else {
      const dirtyData = extractDirtyData(data, dirtyFields);
      updateTicket(dirtyData, {
        onSuccess: () => {
          reset();
        },
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TextInput
        label="First Name"
        type="text"
        name="firstName"
        control={control}
        withAsterisk
        placeholder="User first name"
      />
      <TextInput
        label="Last Name"
        type="text"
        name="lastName"
        control={control}
        mt="md"
        withAsterisk
        placeholder="User last name"
      />
      <TextInput
        label="Email"
        type="text"
        name="email"
        control={control}
        mt="md"
        placeholder="User email"
      />
      <Button
        fullWidth
        mt="md"
        size="sm"
        type="submit"
        loading={creatingTicket}
        color="blue"
        h="40px"
        disabled={!isDirty}
      >
        Submit
      </Button>
    </form>
  );
};

export const openCreateNewTicketModal = ({
  eventId = null,
  ticketData = null,
  action = "create",
}) => {
  modals.open({
    title: action === "edit" ? "Edit Ticket" : "Create Ticket",
    children: (
      <CreateNewTicket
        eventId={eventId}
        action={action}
        ticketData={ticketData}
      />
    ),
  });
};

export default CreateNewTicket;
